// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../index';

import { FilterPriceRangeFragmentDoc } from '../../fragments/filters/filterPriceRange.fragment.generated';
import { MoneyFragmentDoc } from '../../../../fragments/money.fragment.generated';
import { MetalFilterFragmentDoc, MetalFilterMetalFragmentDoc } from '../../fragments/filters/metalFilter.fragment.generated';
export const ReadyToGoRingFiltersFragmentDoc = `
    fragment readyToGoRingFilters on CatalogueReadyToGoRingFilters {
  price(input: {currency: $currency, country: $country}) {
    ...filterPriceRange
  }
  primaryMetals {
    ...metalFilter
  }
}
    `;